<form [formGroup]="mainForm" (ngSubmit)="onSubmit()">
  <lgd-text controlName="username" label="Username" telemetry="Edit-Username">
  </lgd-text>

  <div fxLayout="column" fxLayoutAlign="space-between center" class="login-button-container">
    <forge-button fxFlex type="submit" variant="raised" [disabled]="mainForm.invalid"
      telemetry="Submission-PasswordForm">
      Submit
    </forge-button>

    <forge-button fxFlex (click)="onCancel()" telemetry="Submission-ReturnToLogin">
      Return to sign in
    </forge-button>
  </div>

  <div fxLayout="row" fxLayoutAlign="center center">
    <label class="forge-typography--subheading1 tt-margin--top tt-margin--bottom sent-message">
      If your username has an email address associated with it, you will receive an email with further
      instructions.
      If you do not receive an email, please contact your system administrator.
    </label>
  </div>

  @if (sent) {
    <div fxLayout="row" fxLayoutAlign="center center">
      <label class="forge-typography--subheading1 tt-margin--top tt-margin--bottom sent-message">
        The password change request has been submitted. Please check the associated email for further instructions.
      </label>
    </div>
  }
</form>
